import styled from 'styled-components';

export const StyledBackground = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-family: 'Poppins';

  h1 {
    font-size: 90px;
    color: #63d089;
  }

  p {
    padding: 15px;
    font-size: ${({ theme }) => theme.fontSizes.medium};
    text-align: center;
  }
`;

export const StyledImage = styled.img`
  width: 100%;
`;
